import React from "react"

import { Box } from "@singita/components"

const Dates = ({ form, setDates }) => {
  const { startDate, endDate } = form
  return <Box sx={{ height: "350px" }}></Box>
}

export default Dates
